<template>
  <div>
    <validation-observer>
      <b-form-group>
        <label>{{ $t('member.form.label.jerseyNumber') }} <span class="text-danger">*</span></label>
        <validation-provider
          #default="{ errors }"
          rules="required|between:1,500"
          name="jerseyNumber"
        >
          <b-form-input
            v-model="jerseyNumber"
            v-b-modal.modal-sm
            :state="errors.length > 0 ? false:null"
            :placeholder="$t('member.form.placeholder.enterJerseyNumber')"
            readonly
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </validation-observer>
    <b-modal
      id="modal-sm"
      size="huge"
      header-bg-variant="light"
      cancel-variant="secondary"
      ok-only
      :ok-title="$t('generic.accept')"
      centered
      :title="$t('generic.selectJersey')"
    >
      <div>
        <form class="greatForm">
          <span
            v-for="item in jerseyNumbers.data"
            :key="item.id"
          >
            <input
              :id="'check' + item.id"
              v-model="jerseyNumber"
              type="radio"
              name="check"
              :value="item.value"
              :disabled="item.status == 0"
              :class="{'not-available': item.status == 2 }"
            >
            <label
              :for="'check' + item.id"
            >
              <svg
                width="59"
                height="57"
                viewBox="0 0 69 67"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  fill="none"
                  fill-rule="nonzero"
                >
                  <path
                    d="M58.957 23.69c-.013-.038-1.212-3.868-2.74-8.005-2.116-5.728-3.77-9.153-5.049-10.47A1.007 1.007 0 0 0 51 5.077c-.003-.003-.006-.006-.012-.006-.004-.003-.007-.003-.01-.006-2.185-1.407-6.532-3.39-11.35-4.666a1.317 1.317 0 0 0-.154-.029C36.899.121 33.667 0 29.59 0c-.029 0-.061 0-.09.003C29.471 0 29.439 0 29.41 0c-4.077 0-7.309.121-9.884.37a1.317 1.317 0 0 0-.154.029c-4.818 1.272-9.165 3.256-11.35 4.666a.025.025 0 0 1-.013.006c-.003.003-.006.003-.01.006a.98.98 0 0 0-.167.138c-1.283 1.32-2.933 4.745-5.05 10.47C1.255 19.822.056 23.652.043 23.69a.954.954 0 0 0 .564 1.171l8.691 3.464a.974.974 0 0 0 1.183-.383c.01-.016.59-.944 1.379-2.29.19 3.936.303 10.187.406 15.876.061 3.404.12 6.615.19 9.036.12 4.152.226 4.388.339 4.64.296.657 1.07.922 3.457 1.18 1.36.147 3.213.275 5.508.38a283.225 283.225 0 0 0 7.653.236h.18c.03 0 .062 0 .09-.003.929-.016 4.245-.08 7.564-.233 2.297-.105 4.15-.233 5.507-.38 2.385-.255 3.161-.52 3.458-1.18.113-.252.219-.488.338-4.64.068-2.42.13-5.636.19-9.036.103-5.69.216-11.94.406-15.876.79 1.346 1.37 2.274 1.38 2.29a.97.97 0 0 0 1.182.383L58.4 24.86a.958.958 0 0 0 .558-1.17zM29.297 5.232c-.028 0-.06 0-.09.003-.028-.003-.06-.003-.089-.003-2.89 0-5.255-.74-7.033-2.206a7.89 7.89 0 0 1-1.055-1.05c2.22-.153 4.883-.228 8.088-.228.029 0 .061 0 .09-.003.029.003.06.003.09.003 3.205 0 5.871.075 8.088.228a7.89 7.89 0 0 1-1.055 1.05c-1.778 1.465-4.142 2.206-7.033 2.206zm20.316 21.022a117.566 117.566 0 0 1-2.468-4.316.958.958 0 0 0-1.797.34c-.348 2.8-.502 11.57-.643 19.307-.058 3.29-.115 6.397-.18 8.79-.063 2.408-.127 3.495-.169 3.979-.602.154-2.424.452-7.822.69-3.282.144-6.429.198-7.03.211a291.11 291.11 0 0 1-7.029-.208c-5.4-.238-7.223-.536-7.825-.69-.044-.487-.105-1.574-.17-3.98-.063-2.391-.12-5.499-.179-8.789-.137-7.737-.294-16.507-.643-19.307a.958.958 0 0 0-1.796-.34 117.566 117.566 0 0 1-2.469 4.317l-7.056-2.845c1.245-3.931 3.9-11.678 5.923-15.347l2.616 10.246a.962.962 0 0 0 1.168.695.96.96 0 0 0 .692-1.17L9.77 6.223c1.723-1.017 5.1-2.659 9.432-3.896a9.5 9.5 0 0 0 1.85 2.16 10.84 10.84 0 0 0 3.276 1.938c1.515.574 3.221.862 5.081.862.03 0 .061 0 .09-.003.029.003.06.003.09.003 1.857 0 3.566-.292 5.08-.862a10.775 10.775 0 0 0 3.276-1.937 9.417 9.417 0 0 0 1.85-2.161c4.333 1.234 7.714 2.88 9.433 3.896l-2.965 11.614a.962.962 0 0 0 .932 1.2c.429 0 .82-.29.928-.725L50.74 8.066c2.027 3.669 4.678 11.413 5.923 15.347l-7.05 2.841z"
                    fill="#A3D1FF"
                  />
                  <path
                    d="M58.957 23.69c-.013-.038-1.212-3.868-2.74-8.005-2.116-5.728-3.77-9.153-5.049-10.47A1.007 1.007 0 0 0 51 5.077c-.003-.003-.006-.006-.012-.006-.004-.003-.007-.003-.01-.006-2.185-1.407-6.532-3.39-11.35-4.666a1.317 1.317 0 0 0-.154-.029C36.899.121 33.667 0 29.59 0c-.029 0-.061 0-.09.003C29.471 0 29.439 0 29.41 0c-4.077 0-7.309.121-9.884.37a1.317 1.317 0 0 0-.154.029c-4.818 1.272-9.165 3.256-11.35 4.666a.025.025 0 0 1-.013.006c-.003.003-.006.003-.01.006a.98.98 0 0 0-.167.138c-1.283 1.32-2.933 4.745-5.05 10.47C1.255 19.822.056 23.652.043 23.69a.954.954 0 0 0 .564 1.171l8.691 3.464a.974.974 0 0 0 1.183-.383c.01-.016.59-.944 1.379-2.29.19 3.936.303 10.187.406 15.876.061 3.404.12 6.615.19 9.036.12 4.152.226 4.388.339 4.64.296.657 1.07.922 3.457 1.18 1.36.147 3.213.275 5.508.38a283.225 283.225 0 0 0 7.653.236h.18c.03 0 .062 0 .09-.003.929-.016 4.245-.08 7.564-.233 2.297-.105 4.15-.233 5.507-.38 2.385-.255 3.161-.52 3.458-1.18.113-.252.219-.488.338-4.64.068-2.42.13-5.636.19-9.036.103-5.69.216-11.94.406-15.876.79 1.346 1.37 2.274 1.38 2.29a.97.97 0 0 0 1.182.383L58.4 24.86a.958.958 0 0 0 .558-1.17z"
                    fill="#A3D1FF"
                    opacity=".597"
                  />
                  <path
                    d="M29.298 5.232c-.03 0-.061 0-.09.003-.029-.003-.061-.003-.09-.003-2.89 0-5.255-.74-7.033-2.206a7.89 7.89 0 0 1-1.055-1.05c2.22-.153 4.883-.228 8.088-.228.029 0 .061 0 .09-.003.029.003.06.003.09.003 3.205 0 5.871.075 8.088.228a7.89 7.89 0 0 1-1.055 1.05c-1.778 1.465-4.142 2.206-7.033 2.206z"
                    fill="#FAFAFA"
                  />
                </g>
                <text
                  id="OStrail"
                  font-family="asap-condensed"
                  font-size="12"
                  font-weight="600"
                  letter-spacing="1"
                  fill="#000000"
                >
                  <tspan
                    v-if="item.value < 10"
                    x="39%"
                    y="48%"
                  >
                    {{ item.label }}
                  </tspan>
                  <tspan
                    v-else-if="item.value >= 10 && item.value <= 99"
                    x="35%"
                    y="48%"
                  >
                    {{ item.label }}
                  </tspan>
                  <tspan
                    v-else-if="item.value >= 100 && item.value <= 999"
                    x="28%"
                    y="48%"
                  >
                    {{ item.label }}
                  </tspan>
                </text>
              </svg>
            </label>
          </span>
        </form>
      </div>
      <!-- </b-tabs> -->
      <!-- Buttons -->
      <div>
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="secondary"
          class="btn-icon rounded-circle btn-modal-prev"
          @click="prev"
        >
          <feather-icon icon="ChevronLeftIcon" />
        </b-button>

        <!-- Buttons next -->
        <!-- Buttons -->
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="secondary"
          class="btn-icon rounded-circle btn-modal-next"
          @click="next"
        >
          <feather-icon icon="ChevronRightIcon" />
        </b-button>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-row
          class="aling-left text-center"
        >
          <b-col
            md="2"
            lg="2"
            sm="2"
            class="mb-1"
          >
            <!-- class="text-center" -->
            <!-- Ocupada -->
            <svg
              width="59"
              height="40"
              viewBox="0 0 59 57"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g
                fill="#B3BCC7"
                fill-rule="nonzero"
                stroke="#fff"
              >
                <path
                  d="M58.957 23.69c-.013-.038-1.212-3.868-2.74-8.005-2.116-5.728-3.77-9.153-5.049-10.47A1.007 1.007 0 0 0 51 5.077c-.003-.003-.006-.006-.012-.006-.004-.003-.007-.003-.01-.006-2.185-1.407-6.532-3.39-11.35-4.666a1.317 1.317 0 0 0-.154-.029C36.899.121 33.667 0 29.59 0c-.029 0-.061 0-.09.003C29.471 0 29.439 0 29.41 0c-4.077 0-7.309.121-9.884.37a1.317 1.317 0 0 0-.154.029c-4.818 1.272-9.165 3.256-11.35 4.666a.025.025 0 0 1-.013.006c-.003.003-.006.003-.01.006a.98.98 0 0 0-.167.138c-1.283 1.32-2.933 4.745-5.05 10.47C1.255 19.822.056 23.652.043 23.69a.954.954 0 0 0 .564 1.171l8.691 3.464a.974.974 0 0 0 1.183-.383c.01-.016.59-.944 1.379-2.29.19 3.936.303 10.187.406 15.876.061 3.404.12 6.615.19 9.036.12 4.152.226 4.388.339 4.64.296.657 1.07.922 3.457 1.18 1.36.147 3.213.275 5.508.38a283.225 283.225 0 0 0 7.653.236h.18c.03 0 .062 0 .09-.003.929-.016 4.245-.08 7.564-.233 2.297-.105 4.15-.233 5.507-.38 2.385-.255 3.161-.52 3.458-1.18.113-.252.219-.488.338-4.64.068-2.42.13-5.636.19-9.036.103-5.69.216-11.94.406-15.876.79 1.346 1.37 2.274 1.38 2.29a.97.97 0 0 0 1.182.383L58.4 24.86a.958.958 0 0 0 .558-1.17zM29.297 5.232c-.028 0-.06 0-.09.003-.028-.003-.06-.003-.089-.003-2.89 0-5.255-.74-7.033-2.206a7.89 7.89 0 0 1-1.055-1.05c2.22-.153 4.883-.228 8.088-.228.029 0 .061 0 .09-.003.029.003.06.003.09.003 3.205 0 5.871.075 8.088.228a7.89 7.89 0 0 1-1.055 1.05c-1.778 1.465-4.142 2.206-7.033 2.206zm20.316 21.022a117.566 117.566 0 0 1-2.468-4.316.958.958 0 0 0-1.797.34c-.348 2.8-.502 11.57-.643 19.307-.058 3.29-.115 6.397-.18 8.79-.063 2.408-.127 3.495-.169 3.979-.602.154-2.424.452-7.822.69-3.282.144-6.429.198-7.03.211a291.11 291.11 0 0 1-7.029-.208c-5.4-.238-7.223-.536-7.825-.69-.044-.487-.105-1.574-.17-3.98-.063-2.391-.12-5.499-.179-8.789-.137-7.737-.294-16.507-.643-19.307a.958.958 0 0 0-1.796-.34 117.566 117.566 0 0 1-2.469 4.317l-7.056-2.845c1.245-3.931 3.9-11.678 5.923-15.347l2.616 10.246a.962.962 0 0 0 1.168.695.96.96 0 0 0 .692-1.17L9.77 6.223c1.723-1.017 5.1-2.659 9.432-3.896a9.5 9.5 0 0 0 1.85 2.16 10.84 10.84 0 0 0 3.276 1.938c1.515.574 3.221.862 5.081.862.03 0 .061 0 .09-.003.029.003.06.003.09.003 1.857 0 3.566-.292 5.08-.862a10.775 10.775 0 0 0 3.276-1.937 9.417 9.417 0 0 0 1.85-2.161c4.333 1.234 7.714 2.88 9.433 3.896l-2.965 11.614a.962.962 0 0 0 .932 1.2c.429 0 .82-.29.928-.725L50.74 8.066c2.027 3.669 4.678 11.413 5.923 15.347l-7.05 2.841z"
                  fill="#B3BCC7"
                />
                <path
                  d="M58.957 23.69c-.013-.038-1.212-3.868-2.74-8.005-2.116-5.728-3.77-9.153-5.049-10.47A1.007 1.007 0 0 0 51 5.077c-.003-.003-.006-.006-.012-.006-.004-.003-.007-.003-.01-.006-2.185-1.407-6.532-3.39-11.35-4.666a1.317 1.317 0 0 0-.154-.029C36.899.121 33.667 0 29.59 0c-.029 0-.061 0-.09.003C29.471 0 29.439 0 29.41 0c-4.077 0-7.309.121-9.884.37a1.317 1.317 0 0 0-.154.029c-4.818 1.272-9.165 3.256-11.35 4.666a.025.025 0 0 1-.013.006c-.003.003-.006.003-.01.006a.98.98 0 0 0-.167.138c-1.283 1.32-2.933 4.745-5.05 10.47C1.255 19.822.056 23.652.043 23.69a.954.954 0 0 0 .564 1.171l8.691 3.464a.974.974 0 0 0 1.183-.383c.01-.016.59-.944 1.379-2.29.19 3.936.303 10.187.406 15.876.061 3.404.12 6.615.19 9.036.12 4.152.226 4.388.339 4.64.296.657 1.07.922 3.457 1.18 1.36.147 3.213.275 5.508.38a283.225 283.225 0 0 0 7.653.236h.18c.03 0 .062 0 .09-.003.929-.016 4.245-.08 7.564-.233 2.297-.105 4.15-.233 5.507-.38 2.385-.255 3.161-.52 3.458-1.18.113-.252.219-.488.338-4.64.068-2.42.13-5.636.19-9.036.103-5.69.216-11.94.406-15.876.79 1.346 1.37 2.274 1.38 2.29a.97.97 0 0 0 1.182.383L58.4 24.86a.958.958 0 0 0 .558-1.17z"
                  fill="#B3BCC7"
                  opacity=".597"
                />
                <path
                  d="M29.298 5.232c-.03 0-.061 0-.09.003-.029-.003-.061-.003-.09-.003-2.89 0-5.255-.74-7.033-2.206a7.89 7.89 0 0 1-1.055-1.05c2.22-.153 4.883-.228 8.088-.228.029 0 .061 0 .09-.003.029.003.06.003.09.003 3.205 0 5.871.075 8.088.228a7.89 7.89 0 0 1-1.055 1.05c-1.778 1.465-4.142 2.206-7.033 2.206z"
                  fill="#B3BCC7"
                />
              </g>
            </svg>
            <label>
              {{ $t('generic.busy') }}
            </label>
          </b-col>
          <b-col
            md="2"
            lg="2"
            sm="2"
            class="mb-1"
          >
            <!-- class="text-center" -->
            <!-- Disponible -->
            <svg
              width="59"
              height="40"
              viewBox="0 0 59 57"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M58.957 23.69c-.013-.038-1.212-3.868-2.74-8.005-2.116-5.728-3.77-9.153-5.049-10.47A1.007 1.007 0 0 0 51 5.077c-.003-.003-.006-.006-.012-.006-.004-.003-.007-.003-.01-.006-2.185-1.407-6.532-3.39-11.35-4.666a1.317 1.317 0 0 0-.154-.029C36.899.121 33.667 0 29.59 0c-.029 0-.061 0-.09.003C29.471 0 29.439 0 29.41 0c-4.077 0-7.309.121-9.884.37a1.317 1.317 0 0 0-.154.029c-4.818 1.272-9.165 3.256-11.35 4.666a.025.025 0 0 1-.013.006c-.003.003-.006.003-.01.006a.98.98 0 0 0-.167.138c-1.283 1.32-2.933 4.745-5.05 10.47C1.255 19.822.056 23.652.043 23.69a.954.954 0 0 0 .564 1.171l8.691 3.464a.974.974 0 0 0 1.183-.383c.01-.016.59-.944 1.379-2.29.19 3.936.303 10.187.406 15.876.061 3.404.12 6.615.19 9.036.12 4.152.226 4.388.339 4.64.296.657 1.07.922 3.457 1.18 1.36.147 3.213.275 5.508.38 3.319.153 6.631.217 7.563.233.029.003.061.003.09.003h.18c.03 0 .062 0 .09-.003.929-.016 4.245-.08 7.564-.233 2.297-.105 4.15-.233 5.507-.38 2.385-.255 3.161-.52 3.458-1.18.113-.252.219-.488.338-4.64.068-2.42.13-5.636.19-9.036.103-5.69.216-11.94.406-15.876.79 1.346 1.37 2.274 1.38 2.29a.97.97 0 0 0 1.182.383L58.4 24.86a.958.958 0 0 0 .558-1.17zM29.297 5.232c-.028 0-.06 0-.09.003-.028-.003-.06-.003-.089-.003-2.89 0-5.255-.74-7.033-2.206a7.89 7.89 0 0 1-1.055-1.05c2.22-.153 4.883-.228 8.088-.228.029 0 .061 0 .09-.003.029.003.06.003.09.003 3.205 0 5.871.075 8.088.228a7.89 7.89 0 0 1-1.055 1.05c-1.778 1.465-4.142 2.206-7.033 2.206zm20.316 21.022a117.566 117.566 0 0 1-2.468-4.316.958.958 0 0 0-1.797.34c-.348 2.8-.502 11.57-.643 19.307-.058 3.29-.115 6.397-.18 8.79-.063 2.408-.127 3.495-.169 3.979-.602.154-2.424.452-7.822.69-3.282.144-6.429.198-7.03.211a291.11 291.11 0 0 1-7.029-.208c-5.4-.238-7.223-.536-7.825-.69-.044-.487-.105-1.574-.17-3.98-.063-2.391-.12-5.499-.179-8.789-.137-7.737-.294-16.507-.643-19.307a.958.958 0 0 0-1.796-.34 117.566 117.566 0 0 1-2.469 4.317l-7.056-2.845c1.245-3.931 3.9-11.678 5.923-15.347l2.616 10.246a.962.962 0 0 0 1.168.695.96.96 0 0 0 .692-1.17L9.77 6.223c1.723-1.017 5.1-2.659 9.432-3.896a9.5 9.5 0 0 0 1.85 2.16 10.84 10.84 0 0 0 3.276 1.938c1.515.574 3.221.862 5.081.862.03 0 .061 0 .09-.003.029.003.06.003.09.003 1.857 0 3.566-.292 5.08-.862a10.775 10.775 0 0 0 3.276-1.937 9.417 9.417 0 0 0 1.85-2.161c4.333 1.234 7.714 2.88 9.433 3.896l-2.965 11.614a.962.962 0 0 0 .932 1.2c.429 0 .82-.29.928-.725L50.74 8.066c2.027 3.669 4.678 11.413 5.923 15.347l-7.05 2.841z"
                fill="#B3BCC7"
                fill-rule="evenodd"
              />
            </svg>
            <label>
              {{ $t('generic.available') }}
            </label>
          </b-col>
          <b-col
            md="2"
            lg="2"
            sm="2"
            class="mb-1"
          >
            <!-- class="text-center" -->

            <!-- Seleccionada -->
            <span>
              <svg
                width="59"
                height="40"
                viewBox="0 0 59 57"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  fill="none"
                  fill-rule="evenodd"
                >
                  <path
                    d="M58.957 23.69c-.013-.038-1.212-3.868-2.74-8.005-2.116-5.728-3.77-9.153-5.049-10.47A1.007 1.007 0 0 0 51 5.077c-.003-.003-.006-.006-.012-.006-.004-.003-.007-.003-.01-.006-2.185-1.407-6.532-3.39-11.35-4.666a1.317 1.317 0 0 0-.154-.029C36.899.121 33.667 0 29.59 0c-.029 0-.061 0-.09.003C29.471 0 29.439 0 29.41 0c-4.077 0-7.309.121-9.884.37a1.317 1.317 0 0 0-.154.029c-4.818 1.272-9.165 3.256-11.35 4.666a.025.025 0 0 1-.013.006c-.003.003-.006.003-.01.006a.98.98 0 0 0-.167.138c-1.283 1.32-2.933 4.745-5.05 10.47C1.255 19.822.056 23.652.043 23.69a.954.954 0 0 0 .564 1.171l8.691 3.464a.974.974 0 0 0 1.183-.383c.01-.016.59-.944 1.379-2.29.19 3.936.303 10.187.406 15.876.061 3.404.12 6.615.19 9.036.12 4.152.226 4.388.339 4.64.296.657 1.07.922 3.457 1.18 1.36.147 3.213.275 5.508.38a283.225 283.225 0 0 0 7.653.236h.18c.03 0 .062 0 .09-.003.929-.016 4.245-.08 7.564-.233 2.297-.105 4.15-.233 5.507-.38 2.385-.255 3.161-.52 3.458-1.18.113-.252.219-.488.338-4.64.068-2.42.13-5.636.19-9.036.103-5.69.216-11.94.406-15.876.79 1.346 1.37 2.274 1.38 2.29a.97.97 0 0 0 1.182.383L58.4 24.86a.958.958 0 0 0 .558-1.17zM29.297 5.232c-.028 0-.06 0-.09.003-.028-.003-.06-.003-.089-.003-2.89 0-5.255-.74-7.033-2.206a7.89 7.89 0 0 1-1.055-1.05c2.22-.153 4.883-.228 8.088-.228.029 0 .061 0 .09-.003.029.003.06.003.09.003 3.205 0 5.871.075 8.088.228a7.89 7.89 0 0 1-1.055 1.05c-1.778 1.465-4.142 2.206-7.033 2.206zm20.316 21.022a117.566 117.566 0 0 1-2.468-4.316.958.958 0 0 0-1.797.34c-.348 2.8-.502 11.57-.643 19.307-.058 3.29-.115 6.397-.18 8.79-.063 2.408-.127 3.495-.169 3.979-.602.154-2.424.452-7.822.69-3.282.144-6.429.198-7.03.211a291.11 291.11 0 0 1-7.029-.208c-5.4-.238-7.223-.536-7.825-.69-.044-.487-.105-1.574-.17-3.98-.063-2.391-.12-5.499-.179-8.789-.137-7.737-.294-16.507-.643-19.307a.958.958 0 0 0-1.796-.34 117.566 117.566 0 0 1-2.469 4.317l-7.056-2.845c1.245-3.931 3.9-11.678 5.923-15.347l2.616 10.246a.962.962 0 0 0 1.168.695.96.96 0 0 0 .692-1.17L9.77 6.223c1.723-1.017 5.1-2.659 9.432-3.896a9.5 9.5 0 0 0 1.85 2.16 10.84 10.84 0 0 0 3.276 1.938c1.515.574 3.221.862 5.081.862.03 0 .061 0 .09-.003.029.003.06.003.09.003 1.857 0 3.566-.292 5.08-.862a10.775 10.775 0 0 0 3.276-1.937 9.417 9.417 0 0 0 1.85-2.161c4.333 1.234 7.714 2.88 9.433 3.896l-2.965 11.614a.962.962 0 0 0 .932 1.2c.429 0 .82-.29.928-.725L50.74 8.066c2.027 3.669 4.678 11.413 5.923 15.347l-7.05 2.841z"
                    fill="#A3D1FF"
                  />
                  <path
                    d="M58.957 23.69c-.013-.038-1.212-3.868-2.74-8.005-2.116-5.728-3.77-9.153-5.049-10.47A1.007 1.007 0 0 0 51 5.077c-.003-.003-.006-.006-.012-.006-.004-.003-.007-.003-.01-.006-2.185-1.407-6.532-3.39-11.35-4.666a1.317 1.317 0 0 0-.154-.029C36.899.121 33.667 0 29.59 0c-.029 0-.061 0-.09.003C29.471 0 29.439 0 29.41 0c-4.077 0-7.309.121-9.884.37a1.317 1.317 0 0 0-.154.029c-4.818 1.272-9.165 3.256-11.35 4.666a.025.025 0 0 1-.013.006c-.003.003-.006.003-.01.006a.98.98 0 0 0-.167.138c-1.283 1.32-2.933 4.745-5.05 10.47C1.255 19.822.056 23.652.043 23.69a.954.954 0 0 0 .564 1.171l8.691 3.464a.974.974 0 0 0 1.183-.383c.01-.016.59-.944 1.379-2.29.19 3.936.303 10.187.406 15.876.061 3.404.12 6.615.19 9.036.12 4.152.226 4.388.339 4.64.296.657 1.07.922 3.457 1.18 1.36.147 3.213.275 5.508.38a283.225 283.225 0 0 0 7.653.236h.18c.03 0 .062 0 .09-.003.929-.016 4.245-.08 7.564-.233 2.297-.105 4.15-.233 5.507-.38 2.385-.255 3.161-.52 3.458-1.18.113-.252.219-.488.338-4.64.068-2.42.13-5.636.19-9.036.103-5.69.216-11.94.406-15.876.79 1.346 1.37 2.274 1.38 2.29a.97.97 0 0 0 1.182.383L58.4 24.86a.958.958 0 0 0 .558-1.17z"
                    fill="#A3D1FF"
                    opacity=".597"
                  />
                  <path
                    d="M29.298 5.232c-.03 0-.061 0-.09.003-.029-.003-.061-.003-.09-.003-2.89 0-5.255-.74-7.033-2.206a7.89 7.89 0 0 1-1.055-1.05c2.22-.153 4.883-.228 8.088-.228.029 0 .061 0 .09-.003.029.003.06.003.09.003 3.205 0 5.871.075 8.088.228a7.89 7.89 0 0 1-1.055 1.05c-1.778 1.465-4.142 2.206-7.033 2.206z"
                    fill="#FAFAFA"
                  />
                </g>
              </svg>
              <label>
                {{ $t('generic.selected') }}
              </label>
            </span>
          </b-col>
          <b-col
            md="6"
            lg="6"
            sm="6"
          >
            <div class="float-right mt-1">
              <b-button
                variant="secondary"
                size="md"
                pill
                @click="cancel()"
              >
                {{ $t('buttons.cancel') }}
              </b-button>
              <!-- style="margin-left: 17px;" -->

              <b-button
                variant="primary"
                size="md"
                style="margin-left: 10px;"
                pill
                :style="colorPrimaryBtn"
                @click="ok()"
              >
                {{ $t('generic.accept') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
// import vSelect from 'vue-select'

export default {
  name: 'JerseyNumber',
  components: {
    ValidationProvider,
    ValidationObserver,
    // vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    jerseyNumbers: {
      type: [Object, Array],
      default: null,
    },
    jerseyNumber: {
      type: [String, Number],
      default: null,
    },
    colorPrimaryBtn: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    tabIndex: 1,
    slide: 0,
    sliding: null,
    test: false,
    filters: {
      page: 1,
      perPage: 50,
    },
  }),
  watch: {
    jerseyNumber(value) {
      this.$emit('update:jersey-number', value)
    },
  },
  methods: {
    prev() {
      // if (this.tabIndex <= 0) {
      if (this.tabIndex <= Math.ceil(this.jerseyNumbers.total / 50)) {
        this.tabIndex = 1
        this.handlefilterRange(this.tabIndex)
      } else {
        this.tabIndex -= 1
        this.handlefilterRange(this.tabIndex)
      }
    },
    next() {
      if (this.tabIndex > Math.ceil(this.jerseyNumbers.total / 50) - 1) {
        this.tabIndex = 1
        this.handlefilterRange(this.tabIndex)
      } else {
        this.tabIndex += 1
        this.handlefilterRange(this.tabIndex)
      }
    },
    handlefilterRange(index) {
      // const result = this.rangeNumber.filter(item => item.id === Number(index))[0]
      this.filters.page = index

      this.limitNumber(this.filters)
    },
    limitNumber(range) {
      this.$emit('handle-jersey-by-team-id', range)
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import url(https://fonts.googleapis.com/css?family=Lato:400,700);

.greatForm{
   padding-left: 10px;
   padding-right: 10px;
   align-content: center;
}

.greatForm > span > label{
  position: relative;
  top: 0;
  left:0;
  color: #59637f;
  font-size: 25px;
  background-color: #FFF;
  font-family: Lato;
  font-weight: 900 !important;
  transition: background-color .1s, top .1s;
  display: inline-block;
  svg > g > path {
    stroke: #b3bcc7;
    fill: #FFF;
    fill-rule: nonzero;
  }
  svg > text {
    fill: #98a1b3
  }
}

.greatForm > span > input[type=radio]{
  background-color: #6abeff;
  height: 0em;
  width: 0em;
  background: none;
  display: none;
}
.greatForm > span > input[type=radio]:checked + label{
  top: -2px;
  svg > g > path {
    fill: #6abeff;
    fill-rule: nonzero;
    stroke: #fff;
  }
  svg > text {
    fill: #59637f
  }
  &:hover {
    svg > g > path {
      fill: #6abeff;
      fill-rule: nonzero;
      stroke: #fff;
    }
  }
}
// Hover
.greatForm > span > input[type=radio]:hover + label{
  // top: -2px;
  svg > g > path {
    // fill: #ffffff;
    fill-rule: nonzero;
    stroke: #6abeff;
  }
  svg > text {
    fill: #59637f
  }
}
.greatForm > span > input[type=radio]:disabled + label {
  cursor:no-drop;
  svg > g > path {
    fill: #b3bcc7;
    fill-rule: nonzero;
    stroke: #fff;
  }
  svg > text {
    fill: #98a1b3
  }
}
.not-available + label {
  cursor:no-drop;
  pointer-events: none;
  opacity: 0.4;
}
.btn-modal-next {
  top: 50%;
  position: absolute !important;
  right: -15px;
  transition: all .5s ease;
  z-index: 99;
  box-shadow: 0 7px 10px 0 #98a1b3;
  background-color: #b3bcc7
}
.btn-modal-prev {
  top: 50%;
  position: absolute !important;
  left: -15px;
  transition: all .5s ease;
  z-index: 99;
  box-shadow: 0 7px 10px 0 #98a1b3;
  opacity: 1;
  background-color: #b3bcc7
}

</style>
